import { Grid, Typography } from "@mui/material";

import { toEuro } from "@/utils/format";

function TotalPrice({ totalPrice }: { totalPrice: number }) {
  return (
    <Grid size={{ xs: 12 }} display="flex" justifyContent="center">
      <Typography
        fontWeight="900"
        fontSize="1.3rem"
        sx={{ borderBottom: "3px solid #fe5d8d" }}
        variant="overline"
      >
        Prix Total Du Delivery:
        {toEuro(totalPrice)}
      </Typography>
    </Grid>
  );
}

export default TotalPrice;
